import {
  AdvancedMarker,
  useAdvancedMarkerRef,
  useMap,
} from '@vis.gl/react-google-maps';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';

import { InfoWindowContainer } from './MarkerWithInfoWindow.styles';
import { STREET_VIEW_ZOOM } from '../../constants';

const MarkerWithInfoWindow = ({
  position,
  children,
  shouldCenter = false,
  infoWindowContent = null,
  infoWindowProps = {},
  ...props
}) => {
  const map = useMap();

  const [markerRef, marker] = useAdvancedMarkerRef();

  const [isInfoWindowVisible, setIsInfoWindowVisible] = useState(false);

  const handleMarkerClick = useCallback(() => {
    // Toggle the info window
    setIsInfoWindowVisible((isVisible) => !isVisible);

    if (map && shouldCenter) {
      // Pan to the position and set the zoom to the street view zoom
      map.panTo(position);
      map.setZoom(STREET_VIEW_ZOOM);
    }
  }, [map, position]);

  const handleClose = useCallback(() => setIsInfoWindowVisible(false), []);

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={position}
        onClick={handleMarkerClick}
        {...props}
      >
        {children}
      </AdvancedMarker>
      {infoWindowContent && isInfoWindowVisible && (
        <InfoWindowContainer
          anchor={marker}
          onClose={handleClose}
          headerDisabled
          {...infoWindowProps}
        >
          {infoWindowContent}
        </InfoWindowContainer>
      )}
    </>
  );
};

MarkerWithInfoWindow.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  children: PropTypes.node,
  shouldCenter: PropTypes.bool,
  infoWindowContent: PropTypes.node,
  infoWindowProps: PropTypes.object,
};

export default MarkerWithInfoWindow;
